import { RouterProvider } from "react-router-dom";
import router from "./router";

function App() {
  return (
    <RouterProvider
      router={router}
      fallbackElement={<div>در حال بارگذاری...</div>}
    />
  );
}



export default App;
